import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const assetsRoute: InvariantJiraRoute = {
	name: 'assets',
	path: '/jira/assets',
	exact: true,
};
